// Note: This file is shared between the server and the client.

export const UPLOAD_SIGNATURE_LIFETIME_MS = 60 * 60 * 1000; // 1 hour
